export default __webpack_public_path__ + "static/chip_art-02@2x_1-a1a6002fc76cdf0c3dc9e89281bc69e0.jpeg";